{
  "faqHeading": "Частые вопросы",
  "cities": {
    "nice": {
      "sections": [
        {
          "heading": "Что посмотреть в Ницце",
          "paragraphs": [
            "Начните со Старого города (Вьё-Нис) с его узкими улочками и охристыми фасадами и рынка на Кур-Салея: цветы и местные продукты каждое утро, кроме понедельника, когда площадь занимают антиквары. Поднимитесь на Замковый холм — пешком или на лифте — ради самого известного вида на Залив Ангелов, а затем прогуляйтесь по Променад-дез-Англе: 7 км набережной помогли Ницце в 2021 году войти в список Всемирного наследия ЮНЕСКО как зимнему курорту Ривьеры.",
            "Ницца — ещё и настоящий город искусства. Музей Матисса стоит среди оливковых деревьев района Симье, Национальный музей Марка Шагала хранит его цикл «Библейское послание», а MAMAC посвящён современному искусству начиная с 1950-х. Между музеями парк Променад-дю-Пайон ведёт от Старого города к площади Массена, а набережные порта Лимпия — лучшее место для вечернего бокала."
          ]
        },
        {
          "heading": "События и лучшее время для поездки в Ниццу",
          "paragraphs": [
            "Год открывает Карнавал в Ницце в феврале — две недели шествий и знаменитые «битвы цветов» на Променад-дез-Англе. Летом проходит Nice Jazz Festival (июль), концерты под открытым небом в Театре Зелени и фейерверки над заливом, а осень и зима — сезон театра, Оперы Ниццы и больших выставок.",
            "Лучшие месяцы — май, июнь и сентябрь: тёплое море, длинные дни и меньше туристов, чем в июле и августе. Зимой здесь достаточно тепло, чтобы обедать на террасе, — именно поэтому Ницца когда-то и стала курортом. Что проходит в городе в ваши даты, смотрите в подборке событий выше."
          ]
        },
        {
          "heading": "Как добраться до Ниццы и передвигаться по городу",
          "paragraphs": [
            "Аэропорт Ницца — Лазурный Берег, главные международные ворота Ривьеры, находится всего в 7 км от центра; вторая линия трамвая связывает оба терминала с центром и портом. На вокзал Nice-Ville приходят скоростные TGV из Парижа и региональные поезда TER, идущие вдоль побережья.",
            "Центр компактный, его удобно обходить пешком, а трамвай и автобусы Lignes d'Azur покрывают остальное. Ницца — самая удобная база на Лазурном Берегу: на поезде до Вильфранш-сюр-Мер меньше 10 минут, до Монако и Антиба — 20–25 минут, до Канн и Ментона — заметно меньше часа."
          ]
        }
      ],
      "faq": [
        {
          "q": "Сколько дней нужно на Ниццу?",
          "a": "Двух-трёх дней хватит на Старый город, Замковый холм, Променад-дез-Англе и пару музеев. За четыре-пять дней можно использовать Ниццу как базу для поездок в Монако, Вильфранш-сюр-Мер, Эз, Антиб или Канны — все они легко доступны на поезде."
        },
        {
          "q": "Когда лучше ехать в Ниццу?",
          "a": "В мае, июне и сентябре тепло и можно купаться, но нет толп высокого сезона. В феврале стоит приехать ради Карнавала, в июле — ради Nice Jazz Festival; на эти даты жильё лучше бронировать заранее."
        },
        {
          "q": "Как добраться из аэропорта Ниццы в центр?",
          "a": "Вторая линия трамвая идёт от обоих терминалов до центра и порта примерно за 25–30 минут. У терминалов также есть такси и машины с водителем по приложению."
        },
        {
          "q": "Подходит ли Ницца как база для путешествия по Лазурному Берегу?",
          "a": "Да. Ницца находится в центре побережья, здесь главный аэропорт и вокзал региона, поэтому Монако, Ментон, Вильфранш-сюр-Мер, Антиб и Канны — меньше чем в часе езды на поезде, а многие экскурсии стартуют прямо из города."
        }
      ]
    },
    "cannes": {
      "sections": [
        {
          "heading": "Что посмотреть в Каннах",
          "paragraphs": [
            "Пройдитесь по набережной Круазет с пальмами, роскошными отелями и частными пляжами до Дворца фестивалей, где любой может сфотографироваться на знаменитой лестнице с красной дорожкой. Затем поднимитесь в Сюке — старый квартал на холме с мощёными улочками, церковью Нотр-Дам-д'Эсперанс и музеем в старом замке на вершине, откуда открывается один из лучших видов на залив.",
            "Лучший способ отдохнуть от суеты — выйти в море. Из Старого порта катера за несколько минут доходят до Леринских островов: на Сент-Маргерит — сосновые леса, прозрачные бухты и Королевский форт, где держали Железную маску; на Сент-Онора — действующий монастырь, монахи которого делают собственное вино. А в городе стоит заглянуть на крытый рынок Форвиль — здесь закупаются сами жители Канн."
          ]
        },
        {
          "heading": "События и лучшее время для поездки в Канны",
          "paragraphs": [
            "Канны живут событиями. В мае здесь проходит Каннский кинофестиваль: большинство показов — только для аккредитованных гостей, но прибытие звёзд по красной дорожке и бесплатный кинотеатр под открытым небом на пляже (Cinéma de la Plage) открыты всем. Летом над заливом проходит фестиваль фейерверков, а в сентябре — Cannes Yachting Festival, одна из крупнейших в Европе яхтенных выставок на воде. Круглый год во Дворце фестивалей идут концерты, шоу и выставки.",
            "Для пляжей и спокойной Круазет выбирайте июнь или сентябрь. Цены и число туристов максимальны во время кинофестиваля и в июле–августе, так что при совпадении дат бронируйте заранее."
          ]
        },
        {
          "heading": "Как добраться до Канн и передвигаться по городу",
          "paragraphs": [
            "Ближайший крупный аэропорт — Ницца — Лазурный Берег, примерно в 30 км, откуда в Канны идут прямые автобусы. Вокзал Канн находится в самом центре, на прибрежной линии Марсель — Ницца: сюда приходят TGV из Парижа и частые региональные поезда, до Ниццы — около 30–40 минут.",
            "Центр, Круазет и Сюке легко обойти пешком. Городские автобусы обслуживают дальние районы, а катера на Леринские острова отходят из Старого порта в течение всего дня."
          ]
        }
      ],
      "faq": [
        {
          "q": "Можно ли обычному туристу попасть на Каннский кинофестиваль?",
          "a": "Официальные показы в основном доступны только аккредитованным профессионалам и приглашённым гостям, но посмотреть на красную дорожку у Дворца фестивалей и сходить на бесплатные сеансы Cinéma de la Plage на пляже во время фестиваля может любой."
        },
        {
          "q": "Как добраться из Канн до Леринских островов?",
          "a": "Катера отходят из Старого порта рядом с Дворцом фестивалей. До острова Сент-Маргерит — около 15 минут; на остров Сент-Онора ходят катера самого монастыря. Возьмите с собой воду и перекус: инфраструктура на островах минимальна."
        },
        {
          "q": "Какое расстояние между Каннами и Ниццей?",
          "a": "Около 30 км. Региональный поезд идёт между центрами городов примерно 30–40 минут, также есть прямые автобусы из аэропорта Ниццы."
        },
        {
          "q": "Когда лучше ехать в Канны?",
          "a": "Июнь и сентябрь сочетают тёплую погоду и тёплое море с умеренным потоком туристов. Приезжайте в мае ради атмосферы кинофестиваля или в сентябре на Cannes Yachting Festival — но учтите, что отели в эти даты заметно дороже."
        }
      ]
    },
    "monaco": {
      "sections": [
        {
          "heading": "Что посмотреть в Монако",
          "paragraphs": [
            "У Монако два лица. На Скале (Монако-Виль), в старом городе, находятся Княжеский дворец — со сменой караула каждый день в 11:55, — собор, где похоронена княгиня Грейс, и Океанографический музей, стоящий на утёсе с 1910 года; когда-то его директором был Жак-Ив Кусто. По другую сторону порта Монте-Карло воплощает роскошь Прекрасной эпохи: Казино, Опера Монте-Карло и сады перед Hôtel de Paris.",
            "Обойдите порт Эркюль, чтобы увидеть суперъяхты и пройти по части трассы Гран-при — от шиканы у порта до тоннеля. Искупаться можно на Ларвотто, общественном пляже княжества, а десятки бесплатных общественных лифтов и эскалаторов делают крутые улицы гораздо проще, чем кажется."
          ]
        },
        {
          "heading": "События и лучшее время для поездки в Монако",
          "paragraphs": [
            "Календарь Монако полон событий мирового уровня: Международный цирковой фестиваль и ралли Монте-Карло в январе, теннисный турнир Monte-Carlo Masters в апреле, Гран-при Формулы-1 в конце мая или начале июня, Monaco Yacht Show в сентябре и насыщенный зимний сезон оперы, балета и концертов.",
            "Для прогулок лучше всего весна и начало осени. Неделя Гран-при незабываема, но многолюдна и дорога: бронируйте за несколько месяцев или приезжайте через неделю после гонки, когда часть трассы ещё не разобрана. Концерты и шоу на ваши даты смотрите в подборке событий выше."
          ]
        },
        {
          "heading": "Как добраться до Монако и передвигаться по княжеству",
          "paragraphs": [
            "Своего аэропорта в Монако нет: большинство гостей прилетают в Ниццу, примерно в 30 км, и дальше едут на поезде, автобусе или летят вертолётом (около 7 минут). Поезд от Ниццы до станции Монако — Монте-Карло идёт около 20 минут, а до Ментона дальше на восток — ещё 10 минут.",
            "Площадь Монако — около 2 км², так что его легко обойти пешком, тем более с общественными лифтами и хорошей сетью автобусов. Bateau Bus — небольшой паром через порт Эркюль — избавит от прогулки вокруг гавани."
          ]
        }
      ],
      "faq": [
        {
          "q": "Нужен ли паспорт, чтобы попасть в Монако?",
          "a": "Пограничного контроля между Францией и Монако нет — вы просто входите или въезжаете в княжество. Но паспорт лучше иметь при себе: его спрашивают на входе в игровые залы Казино и при заселении в отель. Валюта Монако — евро. Для въезда во Францию туристам из-за пределов Шенгенской зоны нужна шенгенская виза."
        },
        {
          "q": "Можно ли посетить Казино Монте-Карло, не играя?",
          "a": "Да. Атриум открыт для всех, а игровые залы можно осмотреть утром за входную плату. Посетителям должно быть больше 18 лет, при себе нужен документ; вечером действует дресс-код."
        },
        {
          "q": "Как добраться из Ниццы в Монако?",
          "a": "Проще всего на региональном поезде: около 20 минут от вокзала Nice-Ville до станции Монако — Монте-Карло, поезда ходят часто. Вдоль побережья ходят автобусы, а вертолёт из аэропорта Ниццы летит около 7 минут."
        },
        {
          "q": "Хватит ли одного дня на Монако?",
          "a": "За полный день можно увидеть Скалу с Княжеским дворцом и Океанографическим музеем, а также Казино и порт Эркюль в Монте-Карло. Останьтесь на вечер, чтобы увидеть площадь Казино в огнях или сходить на спектакль в Оперу."
        }
      ]
    },
    "antibes": {
      "sections": [
        {
          "heading": "Что посмотреть в Антибе",
          "paragraphs": [
            "Старый город Антиба укрыт за крепостными стенами, перестроенными Вобаном. Начните с замка Гримальди, где в 1946 году работал Пикассо и где сегодня находится Музей Пикассо, затем спуститесь к крытому Провансальскому рынку на Кур-Массена за оливками, сырами и цветами. С бастиона Сен-Жом на море смотрит гигантская скульптура «Номад» Жауме Пленсы.",
            "Порт Вобан — одна из крупнейших марин Европы со знаменитой «набережной миллиардеров», где стоят суперъяхты у подножия звёздчатого форта Карре. За городом прибрежная тропа мыса Антиб вьётся вдоль диких известняковых берегов, а от маяка Гаруп открывается вид от Альп до массива Эстерель."
          ]
        },
        {
          "heading": "События и лучшее время для поездки в Антиб",
          "paragraphs": [
            "Лето принадлежит Жуан-ле-Пену, курортному близнецу Антиба, где каждый июль с 1960 года фестиваль Jazz à Juan заполняет сосновую рощу Пинед-Гульд. В остальное время в городе проходят концерты, выставки и рынки, а старый город вне сезона особенно атмосферен.",
            "Конец весны и сентябрь — лучшее время, чтобы совместить прогулки с песчаными пляжами Жуан-ле-Пена и Гаруп. Июль и август многолюдны, зато праздничны: джаз, вечерние рынки и ночная жизнь."
          ]
        },
        {
          "heading": "Как добраться до Антиба и передвигаться по городу",
          "paragraphs": [
            "Антиб находится примерно в 20 км от аэропорта Ницца — Лазурный Берег. Поезда останавливаются на станциях Антиб и Жуан-ле-Пен: около 20–25 минут от Ниццы и 10–15 минут от Канн.",
            "Старый город, рынок и порт — в нескольких минутах ходьбы от вокзала. Автобусы Envibus ходят на мыс Антиб и в Жуан-ле-Пен, а прибрежную тропу лучше проходить пешком."
          ]
        }
      ],
      "faq": [
        {
          "q": "Чем знаменит Антиб?",
          "a": "Старым городом за крепостными стенами, Музеем Пикассо в замке Гримальди, Провансальским рынком, портом Вобан с суперъяхтами и мысом Антиб. Соседний Жуан-ле-Пен известен песчаными пляжами и фестивалем Jazz à Juan."
        },
        {
          "q": "Когда проходит Jazz à Juan?",
          "a": "Фестиваль Jazz à Juan проходит каждый июль в сосновой роще Пинед-Гульд на берегу моря в Жуан-ле-Пене. Это один из старейших джазовых фестивалей Европы — он проводится с 1960 года."
        },
        {
          "q": "Как добраться из Ниццы в Антиб?",
          "a": "Региональный поезд идёт от вокзала Nice-Ville до станции Антиб около 20–25 минут; от неё несколько минут пешком до старого города. Вдоль побережья от аэропорта Ниццы ходят и автобусы."
        },
        {
          "q": "Где лучше остановиться — в Антибе, Каннах или Ницце?",
          "a": "Антиб меньше и спокойнее Ниццы и Канн, здесь настоящий старый город и хорошие пляжи в Жуан-ле-Пене, а до обоих городов — короткая поездка на поезде. Хороший выбор для тихой базы."
        }
      ]
    },
    "sttropez": {
      "sections": [
        {
          "heading": "Что посмотреть в Сен-Тропе",
          "paragraphs": [
            "Начните со Старого порта, где яхты швартуются напротив пастельных домов и террас кафе вроде Sénéquier. За ним старый рыбацкий квартал Ла-Понш выводит к крошечному пляжу, а короткий подъём — к Цитадели с музеем морской истории и видом на залив. Любителям искусства стоит зайти в Музей Аннонсиад с работами Синьяка, Матисса и Боннара — художников, которые первыми прославили городок.",
            "По вторникам и субботам по утрам на площади Лис под платанами работает рынок провансальских продуктов — здесь же местные играют в петанк. Знаменитые пляжи, включая Пампелон, тянутся вдоль соседней коммуны Раматюэль, а прибрежная тропа вокруг полуострова связывает тихие бухты и смотровые площадки."
          ]
        },
        {
          "heading": "События и лучшее время для поездки в Сен-Тропе",
          "paragraphs": [
            "Сен-Тропе бережёт традиции: Бравады, которые каждый год 16–18 мая проходят с XVI века, наполняют улицы мушкетными залпами и процессиями в честь покровителя города. В конце сентября — начале октября регата Les Voiles de Saint-Tropez собирает в заливе классические и современные парусники.",
            "Июль и август гламурны, но очень многолюдны, а на единственной дороге в город стоят пробки. Июнь и сентябрь — это тёплое море, более простой доступ и городок в самом очаровательном виде."
          ]
        },
        {
          "heading": "Как добраться до Сен-Тропе и передвигаться на месте",
          "paragraphs": [
            "Железнодорожной станции в Сен-Тропе нет. Ближайшая — в Сен-Рафаэле, дальше на автобусе, а ближайшие аэропорты — Тулон-Йер и Ницца (1,5–2 часа по дороге). Приятнее всего прибыть морем: из Сент-Максима круглый год ходят катера (около 15 минут), а в сезон — суда из Сен-Рафаэля, Канн и Ниццы.",
            "Сам городок маленький, его лучше обходить пешком. До пляжей Пампелона и горной деревни Раматюэль — на автобусе, такси или велосипеде."
          ]
        }
      ],
      "faq": [
        {
          "q": "Можно ли доехать до Сен-Тропе на поезде?",
          "a": "Нет. Ближайшая станция — Сен-Рафаэль, примерно в 35 км, оттуда в Сен-Тропе идут автобусы. Многие предпочитают катер из Сент-Максима или сезонный теплоход из Сен-Рафаэля, Канн или Ниццы."
        },
        {
          "q": "Можно ли съездить в Сен-Тропе на один день из Ниццы или Канн?",
          "a": "Да. В сезон из Ниццы и Канн ходят теплоходы, которые дают несколько часов на месте, а многие экскурсии включают трансфер. На машине летом закладывайте минимум два часа в каждую сторону из-за пробок."
        },
        {
          "q": "Когда работает рынок в Сен-Тропе?",
          "a": "Рынок на площади Лис работает круглый год по вторникам и субботам утром: фрукты и овощи, сыры, провансальские ткани и антиквариат."
        },
        {
          "q": "Где находится пляж Пампелон?",
          "a": "Пампелон — песчаный пляж длиной 5 км чуть южнее Сен-Тропе, на территории соседней коммуны Раматюэль. Вдоль него много пляжных клубов, но есть и общественные участки со свободным входом."
        }
      ]
    },
    "menton": {
      "sections": [
        {
          "heading": "Что посмотреть в Ментоне",
          "paragraphs": [
            "Старый город Ментона поднимается от моря в тёплых итальянских тонах к барочной базилике Святого Михаила Архангела, чья площадь с мозаикой из гальки — одна из лучших смотровых точек побережья. У моря Музей Жана Кокто хранит большую коллекцию работ художника, а Свадебный зал в мэрии, расписанный им, открыт для посетителей.",
            "Ментон — ещё и город садов благодаря самому мягкому климату в континентальной Франции. Ботанический сад Валь-Раме и сад Серр-де-ла-Мадон стоят того, чтобы свернуть с маршрута, а на крытом рынке Les Halles можно попробовать знаменитые ментонские лимоны. Для прогулки подойдёт прибрежная тропа вокруг соседнего мыса Мартен, мимо знаменитой хижины Ле Корбюзье."
          ]
        },
        {
          "heading": "События и лучшее время для поездки в Ментон",
          "paragraphs": [
            "Главное событие Ментона — Праздник лимонов в феврале, который проводится с 1930-х годов: гигантские скульптуры из лимонов и апельсинов в садах Бьовэ и шествия платформ, украшенных цитрусами, по набережной. Летом Музыкальный фестиваль Ментона устраивает концерты камерной музыки на площади перед базиликой — одной из самых красивых площадок под открытым небом на Ривьере.",
            "Благодаря микроклимату в Ментоне приятно почти круглый год. Зима и весна идеальны для садов и прогулок, а июнь и сентябрь — для тёплого моря без летних толп."
          ]
        },
        {
          "heading": "Как добраться до Ментона и передвигаться по городу",
          "paragraphs": [
            "Ментон — последний французский город перед Италией, примерно в 30 км к востоку от Ниццы. Поезд из Ниццы идёт около 35 минут с остановками на станциях Ментон и Ментон-Гараван, а до Монако — всего 10 минут. Ближайший международный аэропорт — Ницца — Лазурный Берег.",
            "Центр, старый город и набережную легко обойти пешком. По ту сторону границы большой пятничный рынок Вентимильи — в нескольких минутах на поезде или автобусе."
          ]
        }
      ],
      "faq": [
        {
          "q": "Когда проходит Праздник лимонов в Ментоне?",
          "a": "Праздник лимонов (Fête du Citron) проходит в феврале и длится около двух недель. На шествия и выставку цитрусовых скульптур в садах Бьовэ нужны билеты — на выходные их лучше покупать заранее."
        },
        {
          "q": "Как добраться из Ниццы в Ментон?",
          "a": "Региональный поезд идёт вдоль побережья от вокзала Nice-Ville до Ментона около 35 минут, через Вильфранш-сюр-Мер и Монако. По прибрежной дороге ходят и автобусы."
        },
        {
          "q": "Стоит ли ехать в Ментон?",
          "a": "Да — это самый спокойный город Ривьеры, с итальянским по духу старым городом, прекрасными садами, Музеем Жана Кокто и мягким климатом круглый год. Поездку легко совместить с визитом в Монако."
        },
        {
          "q": "Можно ли съездить из Ментона в Италию?",
          "a": "Очень легко. Итальянская граница — сразу за городом, а до Вентимильи около 10 минут на поезде; её большой пятничный рынок — популярная поездка на полдня."
        }
      ]
    },
    "villefranche": {
      "sections": [
        {
          "heading": "Что посмотреть в Вильфранш-сюр-Мер",
          "paragraphs": [
            "Старый город Вильфранша спускается к одной из самых глубоких естественных бухт Средиземноморья. У рыбацкого порта крошечную часовню Сен-Пьер в 1957 году расписал Жан Кокто — сценами из жизни святого Петра и местных рыбаков. Сразу за ней — Тёмная улица (Rue Obscure), средневековый сводчатый проход, который тянется под домами более чем на 100 метров.",
            "В цитадели Сент-Эльм XVI века сегодня размещаются мэрия, сады и бесплатные музеи. Вдоль бухты тянется пляж Мариньер, а по соседству, на полуострове Сен-Жан-Кап-Ферра, находятся вилла Эфрусси-де-Ротшильд и её сады; чуть дальше, в Больё, — вилла Керилос в греческом стиле."
          ]
        },
        {
          "heading": "События и лучшее время для поездки в Вильфранш-сюр-Мер",
          "paragraphs": [
            "Вильфранш живёт деревенским календарём: в феврале на «Цветочной морской битве» (Combat naval fleuri) украшенные рыбацкие лодки сражаются в гавани цветами, а летом на набережной и в цитадели проходят концерты, фестивали и вечерние мероприятия.",
            "Май, июнь и сентябрь идеальны для купания и прогулок вокруг бухты. В бухте часто встают на якорь круизные лайнеры, и по утрам в такие дни бывает людно — старым городом лучше наслаждаться ближе к вечеру."
          ]
        },
        {
          "heading": "Как добраться до Вильфранш-сюр-Мер и передвигаться на месте",
          "paragraphs": [
            "Вильфранш-сюр-Мер находится между Ниццей и Монако. Поезд из Ниццы идёт меньше 10 минут и останавливается прямо над пляжем Мариньер; до аэропорта Ницца — Лазурный Берег около 20 минут на машине.",
            "Старый город и порт обходят пешком, хотя подъёмы крутые. Автобусы ходят вдоль побережья в Ниццу, Больё-сюр-Мер и Сен-Жан-Кап-Ферра, а прибрежная тропа вокруг мыса начинается совсем рядом."
          ]
        }
      ],
      "faq": [
        {
          "q": "Как добраться из Ниццы в Вильфранш-сюр-Мер?",
          "a": "На региональном поезде — меньше 10 минут от вокзала Nice-Ville. Станция находится прямо над пляжем, в нескольких минутах ходьбы от старого города. Другой вариант — автобусы по прибрежной дороге."
        },
        {
          "q": "Стоит ли ехать в Вильфранш-сюр-Мер?",
          "a": "Да. Это одна из самых сохранившихся деревень Ривьеры: красочный старый город, часовня Кокто, песчаный пляж и удобная дорога в Сен-Жан-Кап-Ферра — и всё в нескольких минутах от Ниццы."
        },
        {
          "q": "Есть ли пляж в Вильфранш-сюр-Мер?",
          "a": "Да, пляж Мариньер — длинный, пологий, из песка и мелкого гравия, вдоль бухты прямо под вокзалом. Вода здесь спокойная и хорошо подходит для купания."
        },
        {
          "q": "Что посмотреть рядом с Вильфранш-сюр-Мер?",
          "a": "Совсем рядом Сен-Жан-Кап-Ферра с виллой Эфрусси-де-Ротшильд, Больё-сюр-Мер с виллой Керилос и горная деревня Эз. До Ниццы меньше 10 минут на поезде, до Монако — около 15."
        }
      ]
    }
  }
}
